import { FC, MouseEventHandler, ReactNode } from 'react';
import { Hamburger } from '@o2/icons';
import { styled } from '@mui/material';
import colors from '@o2/ui/theme/colors';

const StyledButton = styled('button', {
  name: 'AppBar',
  slot: 'MenuButton',
})(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 4,
  alignItems: 'center',
  color: theme.palette.primary.main,
  fontSize: 14,
  fontWeight: 500,
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: theme.spacing(0, 1, 0, 2),
  '&:hover': {
    backgroundColor: colors.transparentWhite[100],
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0, 0, 0, 1.5),
  },
  fontFamily: theme.typography.fontFamily,
}));

export interface MenuButtonProps {
  onClick?: MouseEventHandler;
  text?: ReactNode;
  showHamburger?: boolean;
  showText?: boolean;
}

const MenuButton: FC<MenuButtonProps> = ({
  onClick,
  text = 'Menu',
  showHamburger = true,
  showText = true,
  ...other
}) => {
  return (
    <StyledButton onClick={onClick} {...other}>
      {showHamburger && <Hamburger />}
      {showText && text}
    </StyledButton>
  );
};

MenuButton.displayName = 'AppBar.MenuButton';

export default MenuButton;
